export default function FilePreviewCard({ fileUrl, fileName }) {
  const isImage = /\.(jpg|jpeg|png)$/i.test(fileName);
  // const isDoc = /\.(doc|docx)$/i.test(fileName);
  const isPDF = /\.(pdf)$/i.test(fileName);
  // PDF URL for iframe preview
  const pdfUrl = `${fileUrl}#toolbar=0&navpanes=0&scrollbar=0&zoom=page-fit`;

  return (
    <div className="relative w-[56px] h-[76px] rounded-[4px] overflow-hidden shadow-md bg-gray-100 !border-0">
      {isImage ? (
        <img
          className="w-full h-full object-cover"
          src={fileUrl}
          alt={fileName || "preview"}
        />
      ) : isPDF ? (
        <iframe
          src={pdfUrl}
          title={fileName}
          frameBorder="0"
          scrolling="no"
          className="absolute top-0 left-0 w-[300px] h-[400px]"
          style={{
            transform: "scale(0.19)", // scales 300x400 PDF to fit 56x76 box
            transformOrigin: "top left",
            border: "none",
            pointerEvents: "none",
          }}
        ></iframe>
      ) : (
        <div className="w-full h-full flex flex-col items-center justify-center text-gray-500">
          <span className="text-center text-xs">No Preview Available</span>
        </div>
      )}

      {/* Overlay icon */}
      <div className="absolute inset-0 flex items-center justify-center bg-white/50">
        <div className="bg-[#E8F7E7] w-[25px] h-[25px] rounded-[3px] shadow-md">
          <svg
            width="14"
            height="17"
            viewBox="0 0 14 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mt-1 mx-auto"
          >
            <path
              d="M10.3721 7.58145V4.69684C10.3721 3.77878 10.0062 2.89832 9.35483 2.24916C8.70349 1.59999 7.82008 1.2353 6.89894 1.2353C5.9778 1.2353 5.09439 1.59999 4.44305 2.24916C3.79171 2.89832 3.42579 3.77878 3.42579 4.69684V7.58145M4.44305 11.4156L6.04851 13.2516L9.35483 10.1783M2.84693 16.2353H10.951C11.4115 16.2353 11.8532 16.0529 12.1789 15.7284C12.5046 15.4038 12.6875 14.9636 12.6875 14.5045V9.31222C12.6875 8.85319 12.5046 8.41296 12.1789 8.08838C11.8532 7.7638 11.4115 7.58145 10.951 7.58145H2.84693C2.38636 7.58145 1.94465 7.7638 1.61898 8.08838C1.29331 8.41296 1.11035 8.85319 1.11035 9.31222V14.5045C1.11035 14.9636 1.29331 15.4038 1.61898 15.7284C1.94465 16.0529 2.38636 16.2353 2.84693 16.2353Z"
              stroke="#0D8000"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
